export default __webpack_public_path__ + "static/media/file_type_html_icon_130541.8c11e1a8.svg";